import LoginPage from "./LoginPage";

const page = LoginPage;
export default page;
